import { observer } from 'mobx-react';
import { makeAutoObservable } from 'mobx';
import { IDocumentSearchScope, IUserConfigPackage } from '../../../API';
import ReusableDialog, { IReusableDialogFooterProps, ReusableDialogState } from '../../controls/ReusableDialog';
import { InfoTooltipLabel } from '../../controls/InfoTooltipLabel';
import { Stack, TextField } from '@fluentui/react';
import { useEffect } from 'react';

export class SearchScopeEditorState implements IDocumentSearchScope {
	public userConfig: IUserConfigPackage;

	public dialog:ReusableDialogState;

	public Id: string = '';
	public Title: string = '';
	public Scope: string = '';

	//Unused
	//-------------
	public DisplayTitle: string = '';
	public ServerRelativeUrl: string = '';
	public NativeMetadataUrl: string = '';
	original: IDocumentSearchScope = {} as IDocumentSearchScope;
	//-------------

	private thisItem() : IDocumentSearchScope {
		return {
			Id: this.Id,
			Scope: this.Scope,
			Title: this.Title,
			DisplayTitle: this.DisplayTitle,
			ServerRelativeUrl: this.ServerRelativeUrl,
			NativeMetadataUrl: this.NativeMetadataUrl,
		};
	}


	public dialogButtons: IReusableDialogFooterProps = {
		leftButtons: [/*
			{
				text: 'Delete',
				iconProps: {iconName: 'Delete'},
				onClick: (ev) => {
					this.dialog.onDismiss();
					this.onDelete(this.original);
				},
			}
		*/],
		rightButtons: [
			{
				text: 'Cancel',
				onClick: (ev) => {
					this.dialog.onDismiss();
				},
			},
			{
				text: 'Save',
				onClick: (ev) => {
					this.dialog.onDismiss();
					this.onSave(this.original, this.thisItem());
				},
			}
		],
	};

	onSave: (original:IDocumentSearchScope, updated:IDocumentSearchScope) => void;
	onDelete: (profile:IDocumentSearchScope) => void;

	constructor(
		userConfig: IUserConfigPackage,
		onDelete: (profile:IDocumentSearchScope) => void,
		onSave: (original:IDocumentSearchScope, updated:IDocumentSearchScope) => void
	) {
		this.userConfig = userConfig;
		this.onDelete = onDelete;
		this.onSave = onSave;
		
		this.dialog = new ReusableDialogState("Search Scope", 500);

		makeAutoObservable(this);
	}

	public setItem(item:IDocumentSearchScope) {
		this.original = item;
		Object.assign(this, item);
	}
	
	public setTitle(val:string) {
		this.Title = val;
	}

	public setScope(val:string) {
		this.Scope = val;
	}
	
	public async ensureInitialLoaded() : Promise<void> {
		
	}
}

function SearchScopeEditor({
	state
}: {
	state: SearchScopeEditorState
}) {

	useEffect(() => {
		state.ensureInitialLoaded();
	}, [state]);
	
	return (

		<ReusableDialog state={state.dialog} footerButtons={state.dialogButtons}>
			
			<Stack>

				<InfoTooltipLabel label='Title' title='Search scope title'>
				
					<TextField defaultValue={state.Title} onChange={(_, v) => { state.setTitle(v || '') }} />
					
				</InfoTooltipLabel>

				<InfoTooltipLabel label='Scope' title='Search scope'>

					<TextField defaultValue={state.Scope} onChange={(_, v) => { state.setScope(v || '') }} />

				</InfoTooltipLabel>

			</Stack>
		</ReusableDialog>
	);
}

export default observer(SearchScopeEditor);
